<script>
	const _ = require('underscore');
	const { assetUrl } = require('utilities/urlUtilities');

	module.exports = {
		props: {
			qid: {
				required: true
			},
			type: {
				required: true
			},
			text: {
				required: true
			},
			audio: {
				default: null
			},
			options: {
				default: null
			},
			value: {
				default: null
			},
			required: {
				default: false
			},
			onQuestionAnswer: {
				type: Function,
				default() {}
			},
			placeholder: {
				default: ''
			},
			questionTypes: {
				default: {}
			},
			showAudio: {
				default: false
			},
			audioEventData: {
				default: {}
			}
		},
		components: {
			'validated-textarea': require('components/validated-textarea.vue').default,
			'input-item-with-label': require('components/input-item-with-label.vue').default,
			'audio-player-simple': require('components/audio-player-simple.vue').default
		},
		computed: {
			questionOptions() {
				let type = this.type;
				let options = this.options;
				let value = this.value;
				let questionTypes = this.questionTypes;
				let qOpts = [];

				if (options && options.length) {
					let valueMap = {};
					if (value && value.length) {
						valueMap = value.reduce((acc, v) => {
							acc[v] = true;
							return acc;
						}, {});
					}

					qOpts = options.map(o => {
						return _.assign({}, o, {
							selected: valueMap[o.key]
						});
					});
				} else if (questionTypes[type] && questionTypes[type].options) {
					qOpts = questionTypes[type].options;
				}

				return qOpts;
			}
		},
		methods: {
			onItemClick(item) {
				this.onQuestionAnswer(item.key, this.qid);
			},
			assetUrl(url) {
				return assetUrl(url);
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';
	@import 'config/variables';

	.survey-question {
		.question-text {
			margin-bottom: 0.5rem;
		}

		.options {
			display: flex;
			flex-direction: column;

			.option-container {
				display: flex;
				.audio-player-simple {
					margin-left: 0.5rem;
				}
			}
			.option {
				cursor: pointer;
				display: flex;
				flex-direction: column;
				align-items: center;
				justify-content: center;
				width: 3rem;
				margin: 0 0.25rem 0.25rem 0;
				border: 1px solid $c-grey;
				border-radius: 4px;
				padding: 0.5rem 0.25rem;

				img {
					max-width: 2rem;
				}

				&:hover {
					border-color: $c-blue;
				}

				&.selected {
					color: $c-white;
					background-color: $c-blue;
				}
			}
		}

		&.happiness {
			.options .option {
			}
		}

		&.interest {
			.options .option {
				width: 4rem;
			}
		}

		&.required {
			.question-text:before {
				content: '*';
				color: $c-red;
			}
		}
	}

	@media only screen and (min-width: $bp-width-med) {
		.survey-question {
			.options {
				flex-direction: row;
			}

			&.multi {
				.options {
					flex-direction: column;
				}
			}
		}
	}
</style>
<template>
	<div :class="['survey-question', type, { required }]">
		<div class="question-text">
			{{ text }}
			<audio-player-simple
				v-if="showAudio && audio"
				:url="assetUrl(audio)"
				:event-data="audioEventData">
			</audio-player-simple>
		</div>
		<div
			v-if="type !== 'multi' && type !== 'written' && questionOptions && questionOptions.length"
			class="options">
			<div
				v-for="option in questionOptions"
				:key="option.value"
				class="option"
				:class="{
					selected: value === option.value
				}"
				@click="onQuestionAnswer(option.value, qid)">
				<img
					v-if="option.img"
					:src="assetUrl(option.img)" />
			</div>
		</div>
		<div
			v-if="type === 'multi' && questionOptions && questionOptions.length"
			class="options">
			<div
				class="option-container"
				v-for="option in questionOptions"
				:key="option.id">
				<input-item-with-label
					:item="option"
					:on-item-click="onItemClick"
					:name="`question_${qid}`"
					type="checkbox">
				</input-item-with-label>
				<audio-player-simple
					v-if="showAudio && option.audio"
					:url="assetUrl(option.audio)"
					:event-data="audioEventData">
				</audio-player-simple>
			</div>
		</div>
		<validated-textarea
			v-if="type === 'written'"
			class="print-hidden"
			@change.native="onQuestionAnswer($event.target.value, qid)"
			:value="value"
			@input.native="onQuestionAnswer($event.target.value, qid)"
			:placeholder="placeholder">
		</validated-textarea>
	</div>
</template>
